import { Component, OnInit, ViewChild, ElementRef, HostListener } from '@angular/core';
import {ViewEncapsulation} from '@angular/core';
import { environment } from 'src/environments/environment';
import { CartService } from '../../../cart/services/cart.service';
import { StatePersistService } from 'src/app/core/services/state-persist.service';
import { Title } from '@angular/platform-browser';
import { OrderConsts } from '../../constants';

@Component({
    selector: 'my-orders',
    templateUrl: './my-orders.component.html',
    styleUrls: ['./my-orders.component.scss', '../../../cart/cart.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class MyOrdersComponent implements OnInit {
  page_size = 5 //environment.page_size
  imagePath = environment.s3_path + '/' + environment.product_image_folder + '/'
  invoicePdfPath = this.statePersist.magentoCloudUrl + environment.orderInvoiceFolder
  loading = false;
  componentLoaded = false;
  selectedFilter = ''
  nextPage = 1;
  orderList = []
  global_data:any = {};
  filters = []
  totalProductPages = 1;
  totalProductCount = 0;
  noRecord = true;
  loggedInUser: any;
  orderStatueClasses = {'Order placed':'order_placed','Awaiting Pick':'order_placed','In Pick':'in_pick','Partial Delivered':'partial_delivered','Open':'delivered', 'Dispatched':'dispatched', 'Cancelled':'order_incomplete','Not Delivered':'order_incomplete','Unfulfilled':'order_incomplete','Order Cancelled':'order_incomplete' ,'Order Incomplete':'order_incomplete', 'Order Confirmed': 'delivered', 'Partial Refund':'partial', 'Refund':'refund', 'Pending Payment':'pending_payment'}
  constructor(private cartService: CartService,
    private titleService: Title,
    private statePersist: StatePersistService) { }

  ngOnInit(): void {
    this.loggedInUser = this.statePersist.getLocalStorage('currentUser')
    this.statePersist.watchGlobalDataStorage().subscribe(message => {
      this.global_data = this.statePersist.getLocalStorage('global_data')
    })
    this.titleService.setTitle(OrderConsts.MYORDER_PAGE_TITLE);
    this.statePersist.watchmyorderStorage().subscribe(message => {
      this.componentLoaded = false;
      this.selectedFilter = ''
      this.nextPage = 1;
      this.orderList = []
      this.filters = []
      this.totalProductPages = 1;
      this.totalProductCount = 0;
      this.noRecord = true;
      this.viewOrders()
      this.statePersist.emitstoreListing('store list update')
    })
    this.statePersist.setLocalStorage('address-disabled', false)
    this.statePersist.setLocalStorage('retailer-disabled', false)
    this.statePersist.setLocalStorage('product_data', {}, 'search')
    this.statePersist.removeLocalStorage('product_data')
    this.viewOrders()
    
  }

  @ViewChild('stickyMenu') menuElement: ElementRef;
  sticky: boolean = true;
  elementPosition: any;
  ngAfterViewInit(){
    this.elementPosition = this.menuElement.nativeElement.offsetTop;
  }

  @HostListener('window:scroll', ['$event'])
    handleScroll(){
      const windowScroll = window.pageYOffset;
      if(windowScroll >= this.elementPosition){
        this.sticky = false;
      } else {
        this.sticky = true;
      }
    }

  isFirstOpen = false;
  isFirstOpen1 = true;


  maxSize = 6;
  bigTotalItems = 175;
  bigCurrentPage = 1;

filterChange(){
  this.noRecord = true;
  this.orderList = [];
  this.nextPage = 1;
  this.totalProductCount = 0;
  this.totalProductPages = 1
  this.viewOrders()
}

viewOrders() {
  this.cartService.viewOrders({"page_size": this.page_size,'page':this.nextPage,  "filter" : this.selectedFilter, 'website':'1'})
  .subscribe(
    data => {
      if (data.response) {
        if (data.response.status == '1153'){
          this.noRecord = true;
          this.orderList = [];
          this.nextPage = 1;
          this.totalProductCount = 0;
          this.totalProductPages = 1
        }
        else{
          const order_list = data.response.order_items;
          this.totalProductCount = data.response.total_order_count
          this.totalProductPages = data.response.total_pages;
          if (this.selectedFilter == ''){
             this.selectedFilter = data.response.filters_key[data.response.filters_key.length-1]['filter_key']
          }
          this.filters = data.response.filters_key
          
          if (this.totalProductPages < this.nextPage + 1) {
            this.nextPage = null;
          }
          else {
            this.nextPage += 1;
          }
          if (data.response.total_order_count == 0) {
            this.noRecord = true;
            this.orderList = [];
            this.nextPage = 1;
            this.totalProductCount = 0;
            this.totalProductPages = 1
          }
          else {
            this.noRecord = false;
  
          }
          for (let i = 0; i < order_list.length; i++) {
            this.orderList.push(order_list[i]);
          }
        }
      }
      this.loading = false;
      this.componentLoaded = true;
    }
  );
}

onScrollDown (){
  if ((this.nextPage != 1 && this.nextPage !== null) && !this.loading) {
    this.loading = true;
    this.viewOrders()
  }

}



}


